import { Box, Card, Grid, MenuItem, Tooltip, Typography } from "@mui/material";
import { HighlightedtText } from "./HighlightedText";
import { useVirtualScroll } from "@/Common/hooks/Layout/useVirtualScroll";
import { useRef } from "react";
import { normalizeCamelCase } from "@/Washouts/helpers/tables";

const CHILD_HEIGHT = 32;

interface CompletionAssistingListProps {
	onClick: (value: string) => void;
	searchText: string;
	title: string;
	values: string[];
	message?: string;
}

export const CompletionAssistingList = ({ onClick, searchText, title, values, message }: Readonly<CompletionAssistingListProps>) => {
	const ref = useRef<HTMLDivElement>(null);

	const { slidingWindow: virtualValues, paddingBottom, paddingTop } = useVirtualScroll(ref, values, CHILD_HEIGHT);

	return (
		<Card className="w-[200px] pr-1">
			<Grid container direction="column" className="w-full">
				<Grid item className="p-[5px] h-[34px] w-[190px] whitespace-nowrap">
					<Tooltip title={title} arrow followCursor>
						<Typography className="group-label text-primary overflow-hidden overflow-ellipsis">
							{normalizeCamelCase(title)}
						</Typography>
					</Tooltip>
				</Grid>
				<Grid item ref={ref} className="!h-[234px] py-1 overflow-y-auto">
					{message && (
						<MenuItem disabled>
							<Typography component="span" className="!!w-[120px] text-wrap search-menu-item">
								{message}
							</Typography>
						</MenuItem>
					)}
					<Box component="ul" sx={{ paddingBottom: `${paddingBottom}px`, paddingTop: `${paddingTop}px` }}>
						{virtualValues.map((element, key) => {
							const compoundedKey = `${element}-${key}`;
							return (
								<Tooltip key={compoundedKey} title={element} arrow followCursor>
									<MenuItem
										onClick={() => {
											onClick(element);
										}}
										className="!py-1 w-[190px]"
									>
										<HighlightedtText text={element} highlight={searchText} />
									</MenuItem>
								</Tooltip>
							);
						})}
					</Box>
				</Grid>
			</Grid>
		</Card>
	);
};
